import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { grafanaExploreURL } from "@gearbox-protocol/deploy-tools-shared";
import { NewTab } from "./icons";
export const GrafanaLink = props => {
    const { executionId, labels, className, children = "logs", ...options } = props;
    const query = {
        ...labels,
        ...(executionId ? { execution_id: executionId } : {}),
    };
    return (_jsxs("a", { href: grafanaExploreURL(query, options), target: "_blank", className: className, rel: "noopener", children: [children, _jsx(NewTab, {})] }));
};
